import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const IndexTableRowHoverButtonsSlot = props => /*#__PURE__*/_jsx("span", {
  "data-test-id": "sales-content-table-actions",
  children: props.children
});
IndexTableRowHoverButtonsSlot.propTypes = {
  children: PropTypes.any
};
export default IndexTableRowHoverButtonsSlot;